export default __webpack_public_path__ + "static/contact-c9dab471958fb15988f4fdee9fb3dd36.jpg";